export const isArray = (value: unknown): value is unknown[] => Array.isArray(value);
export const isObject = (value: unknown): value is Record<string, unknown> => typeof value === "object" && value !== null && !isArray(value);
export const isFunction = (p: unknown): p is (...args: never[]) => never => typeof p === "function";
